import { Component, OnInit } from '@angular/core';
import { SearchComponent } from '../search/search.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RecordsService } from '../services/records.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public CurrentTerm: String = ' ';
  //public CurrentType: String;
  public SelectedType: string = "all";
  public nbtout = '';
  public nbfara = '';
  public nbtara = '';
  currentRoute = '';
  //public type: string = 'all';

  constructor(public recordService: RecordsService, private router: Router, protected route: ActivatedRoute, public translate: TranslateService) {
    router.events.subscribe(e =>{
      this.currentRoute = router.url;
    });
   }

  ngOnInit(): void {   
    console.log();
    
    // this.nbtout = this.recordService.nbtout;
    // this.nbfara = this.recordService.nbfara;
    // this.nbtara = this.recordService.nbtara;  

  }

  onSearch(value: any) {
    this.CurrentTerm = value.term;
    this.recordService.advanced = 'false';
    this.recordService.getRecordsByterm(value.term, this.SelectedType, 0);
  }

  init() {
    this.recordService.getRecords(0);
  }
  
  switchLang(lang: string) {
    this.translate.use(lang);
  }

  changetype(type: string) {
    this.SelectedType = type;
    this.recordService.type =  this.SelectedType;
    this.recordService.getRecordsByterm(this.recordService.term, this.SelectedType, 0);
  }

  reset() {
    this.recordService.getRecordsByterm('', this.SelectedType, 0);
  }

  rafraichir() {
    window.location.reload();
  }

}
